import { Controller } from '@hotwired/stimulus'

const VARIABLE_SOURCES = [
  ['contact.name', 'Nome do cliente'],
  ['static', 'Texto fixo'],
]

export default class extends Controller {
  static targets = ['select', 'previewWrapper', 'preview', 'variablesWrapper', 'variablesList']
  static values = { stepIndex: Number }

  templateChanged() {
    const templateId = this.selectTarget.value
    const data = this.lookupTemplate(templateId)
    this.renderPreview(data)
    this.renderVariables(data)
  }

  sourceChanged(event) {
    const select = event.currentTarget
    const row = select.closest('[data-variable-row]')
    if (!row) return
    const staticInput = row.querySelector('[data-engagement-pipeline-template-target="staticInput"]')
    if (!staticInput) return
    if (select.value === 'static') {
      staticInput.classList.remove('hidden')
    } else {
      staticInput.classList.add('hidden')
      staticInput.value = ''
    }
  }

  lookupTemplate(id) {
    if (!id) return null
    const node = document.getElementById('engagement-pipeline-templates')
    if (!node) return null
    try {
      const registry = JSON.parse(node.textContent || '{}')
      return registry[id] || null
    } catch (error) {
      console.error('Failed to parse template registry', error)
      return null
    }
  }

  renderPreview(data) {
    if (!data || !data.body) {
      this.previewWrapperTarget.classList.add('hidden')
      this.previewTarget.innerHTML = ''
      return
    }
    this.previewWrapperTarget.classList.remove('hidden')
    this.previewTarget.innerHTML = this.bodyToHtml(data.body)
  }

  bodyToHtml(body) {
    const escape = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    return body
      .split(/(\{\{[a-zA-Z0-9_]+\}\})/)
      .map((part) => {
        const match = part.match(/^\{\{([a-zA-Z0-9_]+)\}\}$/)
        if (match) {
          return `<span class="inline-block px-1.5 py-0.5 mx-0.5 bg-violet-100 text-violet-800 border border-violet-200 rounded text-xs font-mono align-baseline">{{${match[1]}}}</span>`
        }
        return escape(part)
      })
      .join('')
  }

  renderVariables(data) {
    const placeholders = data?.placeholders || []
    if (placeholders.length === 0) {
      this.variablesWrapperTarget.classList.add('hidden')
      this.variablesListTarget.innerHTML = ''
      return
    }
    this.variablesWrapperTarget.classList.remove('hidden')
    this.variablesListTarget.innerHTML = placeholders
      .map((idx) => this.variableRowHtml(idx))
      .join('')
  }

  variableRowHtml(placeholderIndex) {
    const namePrefix = `pipeline[steps_attributes][${this.stepIndexValue}][template_params_mapping][${placeholderIndex}]`
    const options = VARIABLE_SOURCES.map(
      ([value, label]) => `<option value="${value}">${label}</option>`
    ).join('')

    return `
      <div class="flex items-start gap-3" data-variable-row="${placeholderIndex}">
        <span class="inline-flex items-center justify-center h-10 px-2.5 bg-violet-100 text-violet-800 border border-violet-200 rounded text-xs font-mono shrink-0">{{${placeholderIndex}}}</span>
        <div class="flex-1 space-y-2 min-w-0">
          <select name="${namePrefix}[source]"
            class="select select-bordered bg-white h-10 min-h-10 w-full text-sm"
            data-engagement-pipeline-template-target="sourceSelect"
            data-action="change->engagement-pipeline-template#sourceChanged">
            <option value="" selected>Selecione o valor da variável...</option>
            ${options}
          </select>
          <input type="text" name="${namePrefix}[value]"
            placeholder="Digite o texto fixo..."
            class="input input-bordered bg-white h-10 min-h-10 w-full text-sm hidden"
            data-engagement-pipeline-template-target="staticInput" />
        </div>
      </div>
    `
  }
}
